import { useRef } from 'react';

import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import { useAuthTokens } from '@app/store/zustand';
import { CURRENT_USER_ACCOUNTS } from '@app/store/zustand/wallet/initializeWallets';
import { callGetAccounts } from '@app/store/zustand/wallet/request';

import { parseData } from './parseData';

export function useAccounts() {
    const isFailing = useRef(false);
    const isAuthenticated = useAuthTokens.getState().isAuthenticated;

    const { data, ...rest } = useInfiniteQuery({
        queryKey: [CURRENT_USER_ACCOUNTS],
        queryFn: ({ signal, pageParam }) =>
            callGetAccounts({
                variables: {
                    userFilter: { current: true },
                    withCollectibles: false,
                    cursorInput: {
                        limit: 100,
                        cursor: pageParam || null,
                    },
                },
                settings: { signal },
            }),
        initialPageParam: '',
        select: (response) => parseData(response),
        getNextPageParam: (response) => response?.accounts?.cursor || null,
        staleTime: Infinity,
        enabled: isAuthenticated && !isFailing.current,
        placeholderData: keepPreviousData,
        retry: false,
    });

    isFailing.current = Boolean(rest?.isError || (!rest?.isPending && !data));
    return {
        connectedWallets: !isFailing.current ? data?.pagesData : [] || [],
        ...rest,
    };
}
